import React from "react";
import { Switch, Typography } from "@mui/material";
import classNames from "classnames";

interface Props {
  toggled: boolean;
  onToggle: (param: boolean) => void;
  show?: boolean;
  leftLabel?: React.ReactNode;
  rightLabel?: React.ReactNode;
  className?: string;
}

export const ToggleSwitch = ({toggled, onToggle, leftLabel, rightLabel, className, show}: Props) => {
  if (show === false) return null;

  return (
    <div className={classNames(
      "flex flex-row items-center",
      className
    )}>
      {leftLabel && (typeof leftLabel === 'string' ? <Typography>{leftLabel}</Typography> : leftLabel)}
      <Switch
        checked={toggled}
        sx={{
          "&.MuiSwitch-root .Mui-checked": {
            color: "var(--button-color)",
          },
          "&.MuiSwitch-root .Mui-checked+.MuiSwitch-track": {
            backgroundColor: "var(--button-color)",
            opacity: "50%",
          },
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onToggle(e.target.checked)
        }
      />
      {rightLabel && (typeof rightLabel === 'string' ? <Typography>{rightLabel}</Typography> : rightLabel)}
    </div>
  );
}